import { setBaseUrl } from '@sit/client-shared';

let backendOrigin = import.meta.env.VITE_APP_API_URL || '';

export function updateBackendOrigin(origin: string): void {
  backendOrigin = origin;
  setBaseUrl(origin);
}

const VITE_APP_ADMIN_URL = import.meta.env.VITE_APP_ADMIN_URL || 'https://admin.time.sage.com';
const VITE_APP_DIMENSION_SYNC_TIMEOUT = import.meta.env.VITE_APP_DIMENSION_SYNC_TIMEOUT || '5';
const VITE_APP_INTACCT_WEB_IA_ACCT = import.meta.env.VITE_APP_INTACCT_WEB_IA_ACCT || 'https://www.intacct.com/ia/acct';
const VITE_APP_IS_PRODUCTION = import.meta.env.VITE_APP_IS_PRODUCTION;
const VITE_APP_IS_PREPROD = import.meta.env.VITE_APP_ENV === 'preprod';
const VITE_APP_IS_QA2 = import.meta.env.VITE_APP_ENV === 'qa2';
const VITE_APP_MINUTES_TO_REFRESH_CPTI = import.meta.env.VITE_APP_MINUTES_TO_REFRESH_CPTI || '5';
const VITE_APP_ROW_CHECKS_MIN = import.meta.env.VITE_APP_ROW_CHECKS_MIN || '2';
const VITE_APP_SUPPORTED_BROWSERS_LINK = import.meta.env.VITE_APP_SUPPORTED_BROWSERS_LINK;

export const config = {
  get apiUrl() {
    return backendOrigin;
  },
  get graphqlUrl() {
    return `${this.apiUrl}/graphql`;
  },
  get subscriptionsUrl() {
    return `${this.apiUrl.replace('http', 'ws')}/subscriptions`;
  },
  isProduction: VITE_APP_IS_PRODUCTION !== undefined,
  isCypress: import.meta.env.VITE_APP_ENV === 'cypress',
  get loginEnabled() {
    // On Oct 10th, 2025, we will drop support with standalone SIT web.
    return !this.isProduction || this.isCypress;
  },
  get joinUsModalEnabled() {
    // On Oct 10th, 2025, we will drop support with standalone SIT web.
    return (this.isProduction || VITE_APP_IS_PREPROD || VITE_APP_IS_QA2) && !this.isCypress;
  },
  VITE_APP_ADMIN_URL,
  VITE_APP_DIMENSION_SYNC_TIMEOUT: Number.parseInt(VITE_APP_DIMENSION_SYNC_TIMEOUT),
  VITE_APP_INTACCT_WEB_IA_ACCT,
  VITE_APP_MINUTES_TO_REFRESH_CPTI: Number.parseInt(VITE_APP_MINUTES_TO_REFRESH_CPTI),
  VITE_APP_ROW_CHECKS_MIN: Number.parseInt(VITE_APP_ROW_CHECKS_MIN),
  VITE_APP_SUPPORTED_BROWSERS_LINK,
} as const;

export const intacctUrls = {
  login: `${VITE_APP_INTACCT_WEB_IA_ACCT}/login.phtml`,
  resetPassword: `${VITE_APP_INTACCT_WEB_IA_ACCT}/resetpassword.phtml`,
  ur: `${VITE_APP_INTACCT_WEB_IA_ACCT}/ur.phtml`,
  timeHomepage: 'https://www.sage.com/en-gb/sage-business-cloud/intacct/product-capabilities/extended-capabilities/timesheet-management/',
};
